import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { LandingpageComponent } from './home/landingpage.component';
import { LandingPageLinkComponent } from './home/page-link-block/page-link-block.component';

import { DataDevicesComponentComponent } from '../../projects/dashboard/src/app/data-devices-component/data-devices-component.component';
import { DataOverviewComponentComponent } from '../../projects/dashboard/src/app/data-overview-component/data-overview-component.component';
import { DataUsersComponentComponent } from '../../projects/dashboard/src/app/data-users-component/data-users-component.component';
import { DataApplicationsComponentComponent } from '../../projects/dashboard/src/app/data-applications-component/data-applications-component.component';
import { DataContentComponentComponent } from '../../projects/dashboard/src/app/data-content-component/data-content-component.component';

import { DonutChartDirective } from '../../projects/dashboard/src/app/directive/donut-chart.directive';
import { BarChartDirective } from '../../projects/dashboard/src/app/directive/bar-chart.directive';
import { LineChartDirective } from '../../projects/dashboard/src/app/directive/line-chart.directive';

import { from } from 'rxjs';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToolsModule } from '../../projects/tools/src/lib/tools.module';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";


import { JwtModule  } from '@auth0/angular-jwt';
/* Import auth guard service */
import { AuthGuard } from './auth/auth.guard';
/* Import token interceptor */
import { TokenInterceptor } from './auth/token.interceptor';

import { HeadComponent } from './head/head.component';
export function createTranslateLoader(http: HttpClient) {
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  return new MultiTranslateHttpLoader(http, [
    {prefix: "./assets/i18n/common/", suffix: ".json"},
    {prefix: "./assets/i18n/core/", suffix: ".json"},
    {prefix: "./assets/i18n/project/", suffix: ".json"},
    {prefix: "./assets/i18n/school/", suffix: ".json"},
    {prefix: "./assets/i18n/dashboard/", suffix: ".json"},
    {prefix: "./assets/i18n/classroom/", suffix: ".json"},
    {prefix: "./assets/i18n/content/", suffix: ".json"},
  ]);
}

import { ProjectmanagementSharedModule } from '../../projects/projectmanagement/src/app/app.module';
import { SchoolmanagementSharedModule } from '../../projects/schoolmanagement/src/app/app.module';
import { ContentmanagementSharedModule } from '../../projects/contentmanagement/src/app/app.module';
import { ClassroomSharedModule } from '../../projects/classroom/src/app/app.module';
import { DashboardSharedModule } from '../../projects/dashboard/src/app/app.module';
export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LandingpageComponent,
    ResetpasswordComponent,
    SetpasswordComponent,
    LandingPageLinkComponent,
    HeadComponent,
    DataDevicesComponentComponent,
    DataOverviewComponentComponent,
    DataUsersComponentComponent,
    DataApplicationsComponentComponent,
    DataContentComponentComponent,
    DonutChartDirective,
    BarChartDirective,
    LineChartDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProjectmanagementSharedModule.forRoot(),
    SchoolmanagementSharedModule.forRoot(),
    ContentmanagementSharedModule.forRoot(),
    ClassroomSharedModule.forRoot(),
    DashboardSharedModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NguiAutoCompleteModule,
    ToolsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter
      },
    }),
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    TranslateService
  ],
  exports: [CommonModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
